const pathsRouter = {
  pathAdmin: "", // ejemplo /admin
}

export default pathsRouter;